const defineProperty = Object.defineProperty

/**
 * 定义对象属性，如果属性已存在则重新配置，否则直接赋值
 */
const defineOrSetProperty = <T>(obj: T, key: PropertyKey, value: unknown): T => {
  if (key in (obj as object)) {
    defineProperty(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value
    })
  } else {
    (obj as Record<PropertyKey, unknown>)[key] = value
  }
  return obj
}

/**
 * 确保属性键为字符串（符号类型除外）
 */
const ensureStringKey = <T>(obj: T, key: PropertyKey, value: unknown): T => {
  const normalizedKey = typeof key === 'symbol' ? key : String(key)
  return defineOrSetProperty(obj, normalizedKey, value)
}

class Point2D {
  private longitude: string;
  private latitude: string;

  constructor (longitude: string = '0.000000', latitude: string = '0.000000') {
    ensureStringKey(this, 'longitude', undefined)
    ensureStringKey(this, 'latitude', undefined)
    this.longitude = longitude
    this.latitude = latitude
  }

  /**
   * 从逗号分隔的字符串创建Point2D实例
   */
  static of (coords: string): Point2D {
    const [longitude, latitude] = coords.split(',')
    return new Point2D(longitude, latitude)
  }

  /**
   * 转换为逗号分隔的字符串
   */
  toString (): string {
    return `${this.longitude},${this.latitude}`
  }
}
/**
 * 二维坐标点类
 */
export class GetPoint {
  private coordinates: string;

  constructor (longitude: string = '0.000000', latitude: string = '0.000000') {
    ensureStringKey(this, 'coordinates', undefined)
    this.coordinates = new Point2D(longitude, latitude).toString()
  }

  /**
   * 从逗号分隔的字符串创建GetPoint实例
   */
  static of (coords: string): GetPoint {
    const [longitude, latitude] = coords.split(',')
    return new GetPoint(longitude, latitude)
  }
}
/**
 * 三维坐标点类，继承自Point2D
 */
export class GetNewPoint extends Point2D {
  private altitude: string;

  constructor (
    longitude: string = '0.000000',
    latitude: string = '0.000000',
    altitude: string = '0.000000'
  ) {
    super(longitude, latitude)
    ensureStringKey(this, 'altitude', undefined)
    this.altitude = altitude
  }

  /**
   * 从逗号分隔的字符串创建GetNewPoint实例
   */
  static of (coords: string): GetNewPoint {
    const [longitude, latitude, altitude] = coords.split(',')
    return new GetNewPoint(longitude, latitude, altitude)
  }

  /**
   * 转换为逗号分隔的字符串
   */
  toString (): string {
    return `${super.toString()},${this.altitude}`
  }
}
